<template>
  <div  data-vuetify style="height: 0px !important; width: 0px !important" v-show="dataready"  @click="$store.commit('changeStatus',true)">
    <transition name="fade" appear>
      <div class="modal-overlay"
           v-if="$store.getters.getWidgetState"
           @click="showModal = false"></div>
    </transition>
    <transition name="pop" appear>           
      <div class="modalcustomstyle modal_custom_parent_block"
           role="dialog"
           v-if="$store.getters.getWidgetState"
      >
        <WidgetCart  v-if="!isMobile" />
        <MobileWidgetCart  v-if="isMobile" />
      </div>         
    </transition>
  </div>
</template>

//
<script>

import WidgetCart from "@/components/Widgets/WidgetCart.vue";
import MobileWidgetCart from "@/components/Widgets/MobileWidgetCart.vue";

import { mapGetters } from "vuex";

export default {
  name: "App",
  props: ["instance_id", "cart_id"],

  beforeCreate() {
    this.$store.dispatch("updateToken", "1234").then(() => {
      this.instanceId = document.querySelector("widget-view").instance_id;
      this.$store.dispatch("getWidgets", this.instanceId).then(() => {
        this.$store.dispatch("getSettings", this.instanceId).then(() => {
          this.$store.dispatch("incrementFBKey");
        });
      });
    });
  },
  mounted() {
    setTimeout(() => this.dataready = true ,2700)
  },
  components: {
    WidgetCart,
    MobileWidgetCart
  },
  data() {
    return {
      showModal: true,
      instanceId: "",
      absolute: false,
      opacity: 0.46,
      zIndex: 100000,
      a:[],
      dataready:false,
    };
  },
  computed: {
    ...mapGetters(["getDisplayWidget", "getWidgetsState"]),
    widgetType() {
      return this.getWidgetsState.facebook_widget_type;
    },
    getFbKey() {
      return this.$store.getters.getFbKey;
    },
    overlay() {
      return this.getDisplayWidget ? true : false;
    },
    isMobile() {
      if (screen.width <= 900) {
        return true;
      } else {
        return false;
      }
    },
  },

};
</script>

<style>
.modal_custom_parent_block{
  z-index: 999999 !important;
}  
.alerts-border {
  border: 1px #ff0000 solid !important;
  animation: blink 1s !important;
  animation-iteration-count: 2 !important;
}

@keyframes blink {
  50% {
    border-color: #fff !important;
  }
}
.modal_custom_parent_block{
   border-radius: 25px 25px 0px 0px; 
   font-size: 100%;
   padding-top: 0px;
   padding-left: 0px;
   padding-right: 0px;
   padding-bottom: 0px
}


.header_dims {
  font-size: 100% !important;
  overflow: hidden;
}

.btnfonts_dims {
  font-size: 60% !important;
  overflow: hidden;
}

.page_headers {
  color: #323f4f;
  font-weight: bold !important;
  text-transform: uppercase;
}

@media (min-width: 1400px) {
  .header_dims {
    font-size: 140% !important;
    overflow: hidden;
  }
  .btnfonts_dims {
    font-size: 85% !important;
  }
}

@media (max-width: 900px) {
.modal_custom_parent_block{
  margin-right: 10px !important;
  margin-left: 10px !important;
  background: transparent !important;
}
}


</style>
<style lang="scss">

.modalcustomstyle {
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  text-align: center;
  width: fit-content;
  height: fit-content;
  max-width: 552px ;
  padding:0rem ;
  border-radius: 1rem;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  background:transparent !important;
  z-index: 999;
  transform: none;
}
.modalcustomstyle h1 {
  margin: 0 0 1rem;
}

.modal-overlay {
  content: '';
  position: absolute;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

/* ---------------------------------- */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.pop-enter-active,
.pop-leave-active {
  transition: transform 0.4s cubic-bezier(0.5, 0, 0.5, 1), opacity 0.4s linear;
}

.pop-enter,
.pop-leave-to {
  opacity: 0;
  transform: scale(0.3) translateY(-50%);
}
</style>
